import { useCallback } from 'react';
import { Spinner } from '../common/Spinner';
import { VpsConnectionCard } from './VpsConnectionCard';
import { SystemResourcesCard } from './SystemResourcesCard';
import { DockerContainersCard } from './DockerContainersCard';
import { SyncPanel } from './SyncPanel';
import { LogViewer } from './LogViewer';
import { useVpsStore } from '../../stores/vpsStore';
import { usePolling } from '../../hooks/usePolling';

export default function VpsPage() {
  const status = useVpsStore((s) => s.status);
  const containers = useVpsStore((s) => s.containers);
  const loading = useVpsStore((s) => s.loading);
  const fetchStatus = useVpsStore((s) => s.fetchStatus);
  const fetchContainers = useVpsStore((s) => s.fetchContainers);
  const fetchSyncStatus = useVpsStore((s) => s.fetchSyncStatus);

  const fetchAll = useCallback(async () => {
    await Promise.all([fetchStatus(), fetchContainers(), fetchSyncStatus()]);
  }, [fetchStatus, fetchContainers, fetchSyncStatus]);

  usePolling(fetchAll, 60_000);

  const isInitialLoad = !status && loading;

  if (isInitialLoad) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-4 md:space-y-6">
      {/* Top row: Connection, Resources, Containers */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <VpsConnectionCard status={status} />
        <SystemResourcesCard status={status} />
        <DockerContainersCard containers={containers} />
      </div>

      {/* Middle: Sync Panel */}
      <SyncPanel />

      {/* Bottom: Log Viewer */}
      <LogViewer />
    </div>
  );
}
